var cilSignalCellular3 = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M208.78,264h-.1v.1L16,456.78V496H496V16H456.78Zm-88.1,200H54.035l66.646-66.646Zm88,0h-56V365.354l56-56Zm88,0h-56V277.354l56-56ZM464,464H328.681V189.354L464,54.034Z' class='ci-primary'/>"];

export { cilSignalCellular3 };

